import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

export default class Row extends React.Component {
  _getStatusColor = () => {
    const {document} = this.props;

    if (document && document.status) {
      return `list-scene__status-label_${document.status.toString().toLowerCase()}`;
    }
    return '';
  };

  _getDocumentReadableStatus = () => {
    const {document} = this.props;

    if (document && document.status) {
      return document.status[0].toUpperCase() + document.status.slice(1).toLowerCase();
    }

    return '';
  };

  _getBackgroundColourStyle = () => {
    const {isOdd} = this.props;
    return isOdd ? '_background_color_pale_gray' : '_background_color_white';
  };

  _getTextColourStyle = key => {
    const {sortedBy} = this.props;

    if (sortedBy === key) return 'active';
    return '';
  };

  render() {
    const {document, handleDownloadClick} = this.props;

    return (
      <div id={`documentRowId${document.id}`} className={`list-scene__table-row ${this._getBackgroundColourStyle()}`}>
        <div className={`list-scene__status-bar_left ${this._getStatusColor()}`} />

        <div
          id='documentNameField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element ${this._getTextColourStyle(
            'fileName'
          )} list-scene__table-row-element_place_filler`}
        >
          {document.fileName}
        </div>

        <div
          id='documentTypeField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element ${this._getTextColourStyle(
            'type'
          )} _width_pc_22`}
        >
          {document.typeTitle}
        </div>

        <div
          id='documentEngineTypeField'
          className={`list-scene__table-row-element list-scene__table-row-element_text-element ${this._getTextColourStyle(
            'date'
          )} _width_pc_12`}
        >
          {moment(document.date).local(true).format('MM / DD / YYYY')}
        </div>

        <div className='list-scene__table-row-element list-scene__table-row-element_item-element _width_pc_12'>
          <div
            id='documentStatusField'
            className={`list-scene__status-label ${this._getStatusColor()} ${this._getTextColourStyle('status')}`}
          >
            {this._getDocumentReadableStatus()}
          </div>
        </div>

        <div
          id='documentDownloadButton'
          className='list-scene__table-row-element list-scene__table-row-element_item-element _jc_center _width_pc_12'
        >
          <div
            className='__download-icon _cursor_pointer'
            onClick={handleDownloadClick(document.id, document.fileName)}
          />
        </div>

        <div className={`list-scene__status-bar_right ${this._getStatusColor()}`} />
      </div>
    );
  }
}

Row.propTypes = {
  document: PropTypes.object.isRequired,
  isOdd: PropTypes.bool.isRequired,
  zIndex: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/app/Scenes/DocumentsList/Row.jsx